import { Fragment, useMemo } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import Logo from "./our-collaborator/Logo";

import styles from "./OurCollaborators.module.scss";
import useScreenSize from "hooks/useScreenSize";
import useLang from "hooks/useLang";

const OurCollaborators = () => {
  const { width, breakpoints } = useScreenSize();
  const { lang } = useLang()

  const carouselConfig = useMemo(() => {
    if (width < breakpoints.sm) {
      return {
        direction: "horizontal",
        spaceBetween: 5,
        slidesPerView: 2,
        pauseOnMouseEnter: true,
      };
    }
    return {
      direction: "vertical",
      spaceBetween: 50,
      slidesPerView: 4,
      pauseOnMouseEnter: false,
    };
  }, [width, breakpoints]);

  return (
    <Fragment>
      <section className={["section bg-section", styles.mainSection].join(" ")} id="our-partners">
        <Container className={styles.container}>
          <Row>
            <Col md={7} className="d-flex">
              <Container className={styles.textSection}>
                <h1>{lang.our_collaborators.section_title}</h1>
                <p className="text-muted">{lang.our_collaborators.section_detail}</p>
              </Container>
            </Col>
            <Col md={5}>
              <Row>
                <Col md={6} className={styles.carousel}>
                  <Swiper
                    allowTouchMove={true}
                    loop={true}
                    direction={carouselConfig.direction}
                    spaceBetween={carouselConfig.spaceBetween}
                    slidesPerView={carouselConfig.slidesPerView}
                    autoplay={{
                      pauseOnMouseEnter: carouselConfig.pauseOnMouseEnter,
                      delay: 0,
                      disableOnInteraction: false,
                    }}
                    modules={[Autoplay]}
                    speed={2000}
                  >
                    {[
                      "/images/logo/1_boga_group.png",
                      "/images/logo/2_cj_group.png",
                      "/images/logo/3_pt_humpuss_land.png",
                      "/images/logo/4_pt_united_trakctors_semen_gresik.png",
                      "/images/logo/5_pt_krakatau_medika.png",
                      "/images/logo/6_pt_linksindo_makmur.png",
                      "/images/logo/7_binusa_group.png",
                      "/images/logo/8_pt_ipl_international_logistics.png",
                      "/images/logo/9_pt_medlinx_asia_teknologi.png",
                      "/images/logo/10_pt_color_and_glory.png",
                      "/images/logo/11_pt_bayarind_artha_internusa.png",
                      "/images/logo/12_pt_sang_hyang_seri.png",
                      "/images/logo/13_agrina_group.png",
                      "/images/logo/14_pt_sprint_asia_technology.png",
                      "/images/logo/15_sayurbox.png",
                      "/images/logo/16_pt_socfin_indonesia.png",
                      "/images/logo/18_pt_finaccel_teknologi_indonesia.png",
                      "/images/logo/19_pt_ihi_power_service_indonesia.png",
                      "/images/logo/20_cilegon_fabricators.png",
                      "/images/logo/21_pt_jakarta_propertindo.png",
                      "/images/logo/22_pt_fliptech_lentera_inspirasi_pertiwi.png",
                      "/images/logo/23_pt_palmco_indonesia.png",
                      "/images/logo/24_pt_askara_griya_mahadana.png",
                      "/images/logo/25_pt_transmarco_mong.png",
                      "/images/logo/26_pt_hayam_wuruk_primaindo.png",
                      "/images/logo/27_pt_star_seiki_indonesia.png",
                      "/images/logo/28_pt_karya_ayris_nusantara.png",
                      "/images/logo/29_pt_tiga_insan_sejahtera.png",
                    ].map((logo, i) => (
                      <SwiperSlide key={i}>
                        <Logo src={logo} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
                <Col md={6} className={styles.carousel}>
                  <Swiper
                    allowTouchMove={true}
                    loop={true}
                    direction={carouselConfig.direction}
                    spaceBetween={carouselConfig.spaceBetween}
                    slidesPerView={carouselConfig.slidesPerView}
                    autoplay={{
                      pauseOnMouseEnter: carouselConfig.pauseOnMouseEnter,
                      delay: 0,
                      disableOnInteraction: false,
                      reverseDirection: true,
                    }}
                    modules={[Autoplay]}
                    speed={2000}
                  >
                    {[
                      "/images/logo/30_pt_tamano_indonesia.png",
                      "/images/logo/31_pt_enecal_indonesia.png",
                      "/images/logo/32_pt_sellury_global_indonesia.png",
                      "/images/logo/33_pt_enecal_indonesia.png",
                      "/images/logo/34_taslim_&_partners.png",
                      "/images/logo/35_pt_matrixnet_global_indonesia.png",
                      "/images/logo/36_pt_leica_geosystems.png",
                      "/images/logo/37_pt_hijrah_konsultan_investama.png",
                      "/images/logo/38_hbn_consulting.png",
                      "/images/logo/39_pt_tirta_buana_indoraya.png",
                      "/images/logo/41_pt_feen_marine.png",
                      "/images/logo/42_pt_global_artha_sekawan.png",
                      "/images/logo/42_pt_kenso_indonesia.png",
                      "/images/logo/43_pt_lancar_mitra_abadi_seraya.png",
                      "/images/logo/44_pt_isa_indonesia.png",
                      "/images/logo/45_pt_agenia_indika_mandiri.jpg",
                      "/images/logo/45_pt_endorshine_energy_solutions.png",
                      "/images/logo/46_pt_dwaysindo_akal_perkasa.png",
                      "/images/logo/46_pt_putera_inti_pratama.jpg",
                      "/images/logo/47_pt_arie_karya_utama.png",
                      "/images/logo/48_pt_akufinta_inovasi_consulting.png",
                      "/images/logo/49_pt_gunung_geulis_elok_abadi.png",
                      "/images/logo/50_pt_uniteda_arkato.png",
                      "/images/logo/51_pt_nusahadi_citraharmonis.png",
                      "/images/logo/52_pt_solusi_teknologi_jaya.png",
                      "/images/logo/53_pt_mezra_konsultan_indonesia.png",
                      "/images/logo/54_pt_kimia_farma_diagnostika.png",
                      "/images/logo/55_pt_krakatau_argo_logistics.png",
                    ].map((logo, i) => (
                      <SwiperSlide key={i}>
                        <Logo src={logo} />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
};

export default OurCollaborators;
